import type {AppIconProps} from "../Icons.types";
import {getClassNames} from "../Icons.utils";
import styles from "./Num07.module.scss";

export const Num07Icon = (props: AppIconProps) => {
  const {className, ...rest} = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg {...rest} className={classNames} xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path fill="#000" d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z" opacity="0.6"></path>
      <path fill="#fff" d="M13.583 22c.068-.827.21-1.689.425-2.584s.476-1.774.782-2.635a22.76 22.76 0 011.054-2.431c.385-.77.776-1.434 1.173-1.989H11.9v-2.159h8.245v1.836c-.363.397-.765.946-1.207 1.649-.43.703-.844 1.502-1.241 2.397a23.402 23.402 0 00-1.02 2.856A15.185 15.185 0 0016.15 22h-2.567z"></path>
    </svg>
  );
};
